import i18n from '@/i18n'

export default {
  reportData: {
    title: {},
    items: []
  },
  paymentReportData: {
    title: {},
    items: []
  },
  productReportData: {
    items: []
  },
  sellReportData: {
    items: [],
    paymentsCount: []
  },
  orderReportData: {
    items: [],
    title: {},
    paymentsCount: 0
  },
  orderDurationReportData: {
    items: [],
    title: {}
  },
  orderTimeInStatusReportData: {
    items: [],
    title: {}
  },
  orderTippingReportData: {
    items: [],
    title: {}
  },
  salespersons: [],
  orderTippingSummary: {
    items: [],
    title: {}
  },
  globalReport: {},
  mockGlobalReport: {},
  loading: false,
  type: null,
  query: null,
  colsData: [],
  cols: {},
  json_fields: {},
  json_data: [],
  json_fields_order: {},
  json_data_order: [],
  json_fields_sell_report: {
    Outlet: 'outletID',
    Cashier: 'cashier',
    Date: 'createdAt',
    Sku: 'sku',
    'Product Name': 'name',
    Quantity: 'quantity',
    Total: 'totalPrice',
    [i18n.t('payment_method_name') + ' 1']: 'paymentName_1',
    [i18n.t('payment_method_amount') + ' 1']: 'amount_1',
    [i18n.t('payment_method_name') + ' 2']: 'paymentName_2',
    [i18n.t('payment_method_amount') + ' 2']: 'amount_2',
    [i18n.t('payment_method_name') + ' 3']: 'paymentName_3',
    [i18n.t('payment_method_amount') + ' 3']: 'amount_3'
  },
  json_data_sell_report: [],
  isChangeStore: false,
  count_items: 0,
  currentPath: '',
  isExporting: '',
  productSoldChart: [],
  isLoadingProductSoldChart: false,
  salesOrderData: [],
  customizeFields: []
}
